export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9587.8c8b8f97.jpg";